import { Type } from "class-transformer";
import { observable } from "mobx";
import { enumValue } from "../utils/enumerable";
import Enum from "./enum";

export default class OrderItem {
  @observable licensePlates: string[] = [];
  @observable licensePlate?: string;

  @Type(() => Date)
  @observable
  validSince: Date;

  @Type(() => Date)
  @observable
  validUntil: Date;

  @observable chargeTypeId: string;

  @observable countryId: string;

  @enumValue("charge_types", "chargeTypeId")
  readonly chargeType?: Enum;
}
